import React, { useState, useEffect } from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { UploadImageStyled } from "./styled";
import { useDropzone } from "react-dropzone";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
// import Resizer from 'react-image-file-resizer';
import { IMG_PATH } from "utils/constants/imgPath";
import { Icons } from "components";

const IMAGE_EXTENSION_REGEX = /\.(jpe?g|png|gif|webp|bmp|svg)$/i;

// คืน src สำหรับ preview เฉพาะไฟล์รูป (ไฟล์ใหม่ใช้ blob, ไฟล์เดิมต่อ IMG_PATH) ไฟล์อื่นคืน null
const getPreviewSrc = (file) => {
  if (!file || file.isDelete) return null;
  if (file.isNewUpload) {
    return file.type && file.type.startsWith("image/") ? file.preview : null;
  }
  if (typeof file.media_uri === "string") {
    const path = file.media_uri.split("?")[0];
    if (!IMAGE_EXTENSION_REGEX.test(path)) return null;
    return /^(https?:|blob:|data:)/.test(file.media_uri)
      ? file.media_uri
      : IMG_PATH + file.media_uri;
  }
  return null;
};

const UploadImage = ({
  theme_upload_image,
  heightBox,
  acceptType,
  value,
  onChange,
  onChangeCustom,
  maxMBFileSizeWarning,
  width,
  name,
  fieldName,
  errors,
  label,
  placeholder,
  scaleLabel,
  isDelete,
  disabled,
}) => {
  const customClass = cx({
    theme_upload_image: theme_upload_image,
  });
  const [files, setFiles] = useState([]);
  const [labelShow, setLabelShow] = useState(placeholder || "No file chosen");

  const renderAcceptType = (type) => {
    switch (type) {
      case "cover":
        return {
          "image/jpeg": [".jpeg", ".png"],
        };
      case "png":
        return {
          "image/png": [".png"],
        };
      case "audio":
        return ".mp3,audio/mpeg3";
      case "video":
        return { "video/": [] };
      case "csv":
        return { "text/csv": [".csv"] };
      case "json":
        return { "application/JSON": [".json"] };
      case "img-pdf":
        return { "image/jpeg": [".jpeg", ".png"], "application/pdf": [".pdf"] };
      case "pdf":
        return { "application/pdf": [".pdf"] };
      case "excel":
        return {
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
          "application/vnd.ms-excel": [".xls"],
          "text/csv": [".csv"],
        };
      default:
        break;
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    disabled: disabled,
    accept: { ...renderAcceptType(acceptType) },
    // 1 ฟิลด์เก็บได้ 1 ไฟล์ (เลือกใหม่ = แทนที่ไฟล์เดิม) ยกเว้น csv ที่สะสมไฟล์ได้
    multiple: acceptType === "csv",
    onDrop: async (acceptedFiles) => {
      // ลากวางหลายไฟล์ตอน multiple: false จะได้ acceptedFiles ว่าง
      if (!acceptedFiles || acceptedFiles.length === 0) return;
      if (acceptType !== "csv") {
        if (maxMBFileSizeWarning) {
          let checkFileLimit = acceptedFiles.filter(
            (e) =>
              Number((e.size / 1024 / 1024).toFixed(2)) >
              Number(maxMBFileSizeWarning)
          );
          if (checkFileLimit && checkFileLimit.length > 0) {
            alert("ไฟล์มีขนาดใหญ่ ผู้ใช้อาจต้องใช้เวลานานในการแสดงผล");
          }
        }
        // const imageResize = await resizeFile(acceptedFiles);
        let fileTemp = [
          ...files.filter((e) => !e.isNewUpload),
          ...acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
              isNewUpload: true,
              fieldName: fieldName || name,
            })
          ),
        ];
        setLabelShow(acceptedFiles[acceptedFiles.length - 1].name);
        setFiles(fileTemp);
        onChange && onChange(fileTemp);
        onChangeCustom && onChangeCustom(fileTemp);
      } else {
        let fileTemp = [
          ...files,
          ...acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
              isNewUpload: true,
              fieldName: fieldName || name,
            })
          ),
        ];
        setLabelShow(acceptedFiles[acceptedFiles.length - 1].name);
        setFiles(fileTemp);
        onChange && onChange(fileTemp);
        onChangeCustom && onChangeCustom(fileTemp);
      }
    },
  });

  useEffect(() => {
    if (
      value &&
      value.length === 1 &&
      value[0].media_uri &&
      !value[0].isDelete
    ) {
      let splitName = value[0].media_uri.split("/");
      setLabelShow(splitName[splitName.length - 1]);
      setFiles(value);
    }
    if (value === false) {
      setLabelShow("No file chosen");
      setFiles([]);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const onClickRemove = (index, data) => {
    if (data[0].isNewUpload) {
      let filesTemp = files;
      filesTemp.splice(0, 1);
      setFiles([...filesTemp]);
      onChange && onChange([...filesTemp]);
      onChangeCustom && onChangeCustom([...filesTemp]);
    } else {
      let filesTemp = files;
      filesTemp[0].isDelete = true;
      filesTemp[0].fieldName = fieldName || name;
      let filter = [...filesTemp.filter((e) => !e.isNewUpload)];
      setFiles(filter);
      onChange && onChange(filter);
      onChangeCustom && onChangeCustom(filter);
    }
    setLabelShow("No file chosen");
  };

  // แสดงไฟล์ล่าสุดที่ยังไม่ถูกลบ
  const previewSrc = getPreviewSrc(
    [...files].reverse().find((e) => !e.isDelete)
  );

  return (
    <UploadImageStyled heightBox={heightBox} width={width}>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        {previewSrc && (
          <div className="preview_img_wrap">
            <Zoom>
              <img className="preview_img" alt="preview" src={previewSrc} />
            </Zoom>
          </div>
        )}
        <div className="upload_container">
          <div
            {...getRootProps({
              className: `box_upload ${disabled ? "disabled" : ""}`,
            })}
          >
            <input {...getInputProps()} />
            <div className="box_path">
              <div className="path_name">{labelShow}</div>
            </div>
            <div className="btn_upload">Browse</div>
          </div>
          {isDelete &&
            files &&
            files.length > 0 &&
            files.filter((e) => !e.isDelete).length > 0 && (
              <div
                className="remove_image"
                onClick={() => onClickRemove(0, files)}
              >
                <Icons.CloseX />
              </div>
            )}
        </div>
        {scaleLabel && (
          <div className="input_upload_scale_label">{scaleLabel}</div>
        )}
      </div>
      {errors && <div className="errors">{errors}</div>}
    </UploadImageStyled>
  );
};

UploadImage.propTypes = {};

export default UploadImage;
